import React from 'react';

import get from 'lodash.get';

import { LivePreviewErrorBoundary } from 'components/LivePreviewErrorBoundary/LivePreviewErrorBoundary';
import BlockWrapper from 'components/ModularBlocks/BlockWrapper';

import { BlogPostI } from 'interfaces/content-stack/blogPost';
import { ModularBlockI, modularBlockComponents } from 'interfaces/content-stack/modular-blocks/modularBlocks.types';

import modularBlockShape from 'shapes/modularBlockShape';

import { getBlockType } from 'utils/modularBlockUtils';

ModularBlock.propTypes = {
  data: modularBlockShape,
};

interface ModularBlockProps {
  data: ModularBlockI;
  blogPost?: {
    edges: {
      node: BlogPostI[];
    }[];
  }[];
}

function ModularBlock({ data, ...props }: ModularBlockProps) {
  const blockType = getBlockType(data);
  const promo = blockType?.includes('promotion');
  // TODO: find a more elegant way to determine all blocks related to promo
  // banners
  const checkForLabel: string = get(data, 'blockGroupStart.internalLabel') ?? '';

  if (!blockType) {
    return null;
  }

  const ModularBlockComponent = modularBlockComponents[blockType];

  if (!ModularBlockComponent) {
    return null;
  }

  return (
    <BlockWrapper
      blockType={blockType}
      data={data[blockType] as any} // to be updated with continue mod block typing
      promoBanners={promo || checkForLabel?.includes('promotion')}
    >
      <LivePreviewErrorBoundary componentName={blockType}>
        <ModularBlockComponent data={data[blockType]} className={`modular-block-${blockType}`} {...props} />
      </LivePreviewErrorBoundary>
    </BlockWrapper>
  );
}

export default React.memo(ModularBlock);
